import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Table, Button, Pagination } from "react-bootstrap";
import { FaEdit, FaTrash, FaArrowLeft } from "react-icons/fa";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const getAuthToken = () => localStorage.getItem("authToken");

const ContraList = () => {
    const [contras, setContras] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 50;
    const navigate = useNavigate();

    useEffect(() => {
        fetchContras(currentPage);
    }, [currentPage]);

    const fetchContras = async (page) => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-contras?page=${page}&limit=${limit}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setContras(response.data.contras);
            setTotalPages(response.data.pagination.total_pages);
        } catch (error) {
            console.error("Error fetching contra transactions:", error);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this contra transaction?")) return;

        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");

        try {
            const response = await axios.post(`${appConstants.API_ROOT_URL}delete-contra`, 
                { contra_id: id }, 
                {
                    headers: { 
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            alert(response.data.message || "Contra transaction deleted successfully!");
            fetchContras(currentPage);
        } catch (error) {
            console.error("Error deleting contra transaction:", error);
            alert(error.response?.data?.message || "Error deleting contra transaction. Please try again.");
        }
    };

    return (
        <Layout>
            <div className="p-3 bg-light">
                <Button variant="secondary" onClick={() => navigate(-1)}>
                    <FaArrowLeft /> Back
                </Button>
                <h5 className="mt-3">Contra Transactions</h5>
                <Table striped bordered hover className="mt-3">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>No</th>
                            <th>From Account</th>
                            <th>To Account</th>
                            <th>Amount</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contras.map(contra => (
                            <tr key={contra.id}>
                                <td>{contra.date}</td>
                                <td>{contra.contra_number}</td>
                                <td>{contra.from_account}</td>
                                <td>{contra.to_account}</td>
                                <td>{contra.amount}</td>
                                <td>{contra.description}</td>
                                <td>
                                    <Button variant="warning" size="sm" onClick={() => navigate(`/edit-contra/${contra.id}`)}>
                                        <FaEdit />
                                    </Button>
                                    <Button variant="danger" size="sm" className="ms-2" onClick={() => handleDelete(contra.id)}>
                                        <FaTrash />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                <Pagination>
                    <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} />
                    {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item key={index} active={index + 1 === currentPage} onClick={() => setCurrentPage(index + 1)}>
                            {index + 1}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} />
                </Pagination>
            </div>
        </Layout>
    );
};

export default ContraList;
